import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsEquipment, PmsEquipment } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsEquipment>
    useData={usePmsEquipment}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
